import './utils/loadCookieConsent';
import './utils/initMvAgentAuth';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { Actions } from './actions/enums';
import App from './App';
import { IdentityProvider } from './providers/IdentityProvider';
import { TranslationsProvider } from './providers/TranslationsProvider';
import { RedirectProvider } from './providers/RedirectProvider';

const container = document.createElement('div');
container.id = 'mv-agent-root';
document.body.appendChild(container);
const root = createRoot(container);

if (process.env.NODE_ENV === 'development' && !globalThis.ikea.pubsub) {
  let listeners: { msg: string; cb: (payload: unknown) => void }[] = [];
  const eventsHistory: { namespace: string; event: string; body: unknown; time: number }[] = [];
  if (!globalThis.ikea) {
    globalThis.ikea = {} as typeof globalThis.ikea;
  }

  globalThis.ikea.pubsub = {
    subscribe: (msg: string, cb: (payload: unknown) => void) => listeners.push({ msg, cb }),
    unsubscribe: (targetMsg: string, targetCb?: (payload: unknown) => void) => {
      listeners = listeners.filter(({ msg, cb }) => msg !== targetMsg || cb !== targetCb);
    },
    eventsHistory,
    publish: (targetMsg: string, payload: unknown) => {
      eventsHistory.push({
        namespace: 'mv-agent-dev-mock',
        event: targetMsg,
        body: payload,
        time: Date.now(),
      });
      for (const entry of listeners) {
        if (entry.msg === targetMsg) {
          entry.cb(undefined);
        }
      }
    },
  };
}

root.render(
  <StrictMode>
    <TranslationsProvider>
      <IdentityProvider>
        <RedirectProvider>
          <App />
        </RedirectProvider>
      </IdentityProvider>
    </TranslationsProvider>
  </StrictMode>,
);

globalThis.ikea.mvAgent = globalThis.ikea.mvAgent ?? {};
globalThis.ikea.mvAgent.useSideMenu = () => true; // is this needed checkout, we don't use it in PP

globalThis.ikea.pubsub.publish(Actions.PROFILE_MODAL_LOADED);

globalThis.ikea.mvAgent.profilePagesFragmentLive = globalThis.ikea.pubsub.eventsHistory?.some(
  (event) => event?.event === Actions.PROFILE_NEW_VERSION_RUNNING,
);

globalThis.ikea.pubsub.subscribe(Actions.PROFILE_NEW_VERSION_RUNNING, () => {
  globalThis.ikea.mvAgent.profilePagesFragmentLive = true;
});

// old version support
// // newer version has navteam just publish PROFILE/OPEN_MENU themselves
document.getElementById('hnf-header-profile')?.addEventListener?.('click', (e) => {
  e?.preventDefault?.();
  globalThis.ikea?.pubsub?.publish?.(Actions.PROFILE_OPEN_MENU);
});
